import React from "react";
import {AppBar, Box, Grid, Link, Typography, useMediaQuery} from "@mui/material";
import Copyright from "../../Copyright/Copyright";
import {useTranslation} from "react-i18next";
import {ASSOCIATES, LAST_UPDATE} from "../../../constants";

function MinimizedFooter() {
    const {t} = useTranslation('common');
    const lgDown = useMediaQuery(theme => theme.breakpoints.down('lg'));

    return (
        <AppBar
            sx={{
                padding: theme => theme.spacing(1),
                position: 'relative',
                top: 'auto',
                bottom: 0,
                backgroundColor: theme => theme.palette.appBar.main,
            }}
            elevation={0}
        >
            <Grid container justifyContent="center" alignItems="center" direction="row">
                <Grid item xs>
                    <Grid
                        container
                        alignItems="center"
                        justifyContent={lgDown ? "space-evenly" : "flex-start"}
                        direction="row"
                        spacing={2}>
                        {
                            ASSOCIATES.map((associate) => (
                                <Grid key={associate.alt} item>
                                    <Link color="inherit" href={associate.link} target="_blank" rel="noopener">
                                        <img src={associate.src} height="25px" alt={associate.alt}/>
                                    </Link>
                                </Grid>
                            ))
                        }
                    </Grid>
                </Grid>
                <Grid item xs={4}>
                    <Copyright/>
                </Grid>
                <Grid item xs>
                    <Box textAlign="right">
                        <Typography sx={{fontSize: 'small'}}>
                            {`${t("main.components.footer.latest")}: ${LAST_UPDATE}`}
                        </Typography>
                    </Box>
                </Grid>
            </Grid>
        </AppBar>
    );
}

export default MinimizedFooter;